import { render, staticRenderFns } from "./PlayerResourceLogCopies.vue?vue&type=template&id=50c0bb6b&"
import script from "./PlayerResourceLogCopies.vue?vue&type=script&lang=js&"
export * from "./PlayerResourceLogCopies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports